export const bond_type = [
	{ label: 'Surety', value: 'SURETY' },
	{ label: 'Bank-Guarantee', value: 'BANK-GUARANTEE' },
	{ label: 'Escrow', value: 'ESCROW' },
	{ label: 'Cash', value: 'CASH' },
	{ label: 'Others', value: 'OTHERS' },
];
